import React from 'react';
import PropTypes from 'prop-types';
import { useTranslate } from 'react-admin';

const TicketExpenseTypeField = ({ source, record = {} }) => {
    const translate = useTranslate();
    return (
        <span>{ translate(`resources.tickets.expenseType.${record[source]}`) } </span>
      );
};

TicketExpenseTypeField.propTypes = {
    label: PropTypes.string,
    record: PropTypes.object,
    source: PropTypes.string.isRequired,
};

export default TicketExpenseTypeField;
